import React from "react";
import { useApiQuery } from "hooks/use-api-query";
import type { InvestmentsBoard } from "@interfaces/investment";
import { Card, Loading } from "@components/ui";
import SvgWallet2 from "@components/ui/icons/wallet2";
import SvgGraphArrow from "@components/ui/icons/graphArrow";
import SvgTick from "@components/ui/icons/tick";
import { numberToCurrency } from "@components/utils/formatters";
import { CurrencyBoardValue } from "./currencyBoardValue";
import * as Styled from "./Styled";

export const InvestmentBoard: React.FC = () => {
  const { data, isLoading } = useApiQuery<InvestmentsBoard>([
    "investor",
    "investments_board",
  ]);

  const {
    total_invested,
    total_active,
    total_redempted,
    total_rewarded,
    total_received,
  } = data?.wallet || {};

  return (
    <Styled.BoardWrapper>
      <Card header="Minha carteira">
        {isLoading ? (
          <Loading />
        ) : (
          <Styled.BoardContent>
            <CurrencyBoardValue
              icon={<SvgWallet2 />}
              label="Total investido"
              value={total_invested}
            />

            <CurrencyBoardValue
              icon={<SvgGraphArrow style={{ padding: "2px" }} />}
              label="Valor ativo"
              value={total_active}
            />

            <CurrencyBoardValue
              icon={<SvgTick color="#1F4CA0" />}
              label="Valor recebido"
              value={total_received}
              info={
                <>
                  <b>Recebimentos:</b> {numberToCurrency(total_redempted)}
                  <br />
                  <b>Bônus:</b> {numberToCurrency(total_rewarded)}
                </>
              }
            />
          </Styled.BoardContent>
        )}
      </Card>
    </Styled.BoardWrapper>
  );
};
